module.exports = __webpack_public_path__ + "img/people.f6c1d213.svg";